import { Box } from "@chakra-ui/react";

import OrganizationTicketsPerServiceTable from "../../tables/daily/OrganizationTicketsPerService";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../../store/reportEnterpriseInsights";

const OrganizationTicketsPerService = ({
  branchId = null,
  
  branchIndex,
  data,
  numServices = 0,
  branchName = null,
}) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Service" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Service Ticket Demand Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <OrganizationTicketsPerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        
        branchIndex={branchIndex}
      />
    </Box>
  );
};

export default OrganizationTicketsPerService;
